'use client';
import { useState } from 'react';

const tabs = [
{
  id: 'general',
  label: 'Médecine Générale',
  icon: 'fas fa-stethoscope',
  title: 'Médecine Générale & de Proximité',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png",
  imgAlt: 'Médecin généraliste africain en consultation avec un patient dans une salle moderne',
  description: 'Spécialité clé du centre, la médecine générale répond à 80% des demandes de consultation. Nous proposons également la médecine de proximité avec des diagnostics réalisés directement au domicile des patients sur demande.'
},
{
  id: 'pediatrics',
  label: 'Pédiatrie',
  icon: 'fas fa-baby',
  title: 'Pédiatrie',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8771074-1766904917627.png",
  imgAlt: 'Pédiatre africaine examinant un enfant patient dans une salle colorée et accueillante',
  description: 'Prise en charge complète de la santé de l\'enfant avec un espace ludique pour réduire le stress lié aux pathologies et libérer les parents accompagnateurs.'
},
{
  id: 'gynecology',
  label: 'Gynécologie',
  icon: 'fas fa-venus',
  title: 'Gynécologie',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1b22a1c3f-1769177313985.png",
  imgAlt: 'Gynécologue africaine en consultation dans un cabinet médical moderne et bien équipé',
  description: 'Suivi gynécologique complet, consultations prénatales et postnatales, avec un accompagnement personnalisé pour chaque patiente dans un cadre soigné et bienveillant.'
},
{
  id: 'radiology',
  label: 'Radiologie & ORL',
  icon: 'fas fa-x-ray',
  title: 'Radiologie, Ophtalmologie, Fibroscopie & ORL',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1a280bcf4-1772088893551.png",
  imgAlt: 'Radiologue africain examinant des images médicales sur un tableau lumineux dans un hôpital',
  description: 'Plateau technique de pointe pour la radiologie, l\'ophtalmologie, la fibroscopie digestive et l\'ORL. Des équipements conformes aux standards internationaux pour des diagnostics précis.'
}];


const options = [
'Médecine générale : référent pour 80% des consultations',
'Pédiatrie : prise en charge complète de l\'enfant',
'Gynécologie : suivi de la santé féminine',
'Radiologie : imagerie médicale de pointe',
'Diabétologie : maladies métaboliques et chroniques',
'Ophtalmologie, Fibroscopie & ORL'];



export default function TabsSection() {
  const [activeTab, setActiveTab] = useState('general');

  const currentTab = tabs?.find((t) => t?.id === activeTab) || tabs?.[0];

  return (
    <section id="tabs-1" className="wide-100">
      <div className="max-w-7xl mx-auto px-4">
        {/* TABS NAV */}
        <div
          className="flex flex-wrap justify-center mb-10"
          style={{ borderBottom: '2px solid #eee' }}>
          
          {tabs?.map((tab) =>
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className="flex items-center gap-2 px-6 py-4 font-bold text-sm transition-all border-none cursor-pointer bg-transparent"
            style={{
              color: activeTab === tab?.id ? '#0e5932' : '#555',
              borderBottom: activeTab === tab?.id ? '3px solid #0e5932' : '3px solid transparent',
              marginBottom: '-2px',
              fontFamily: 'Lato, sans-serif'
            }}>
              <i className={tab?.icon}></i>
              {tab?.label}
            </button>
          )}
        </div>

        {/* TAB CONTENT */}
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* IMAGE */}
          <div className="w-full lg:w-1/2">
            <img
              src={currentTab?.img}
              alt={currentTab?.imgAlt}
              className="w-full rounded-2xl shadow-2xl object-cover"
              style={{ height: '420px' }} />
          </div>

          {/* TEXT */}
          <div className="w-full lg:w-1/2">
            <h3
              className="text-3xl font-black mb-5"
              style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
              {currentTab?.title}
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              {currentTab?.description}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 mb-8">
              {options?.map((opt, i) =>
              <div key={i} className="flex items-start gap-3 mb-3">
                  <i className="fas fa-angle-double-right mt-1 flex-shrink-0" style={{ color: '#0e5932' }}></i>
                  <p className="text-sm text-gray-600 m-0">{opt}</p>
                </div>
              )}
            </div>

            <a
              href="#"
              className="inline-block px-7 py-3 rounded font-bold text-sm text-white transition-all"
              style={{ backgroundColor: '#0e5932' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0a3f24'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0e5932'}>
              Prendre Rendez-vous
            </a>
          </div>
        </div>
      </div>
    </section>);
}